export interface ShareContactTypes {
    project_id: number;
    first_name: string;
    last_name: string;
    company_name: string | null;
    profile_image?: string | null;
    mobile: string | null;
    landline: string | null;
    email: string;
    address: string | null;
    city: string | null;
    post_code: string | null;
    role_name: string | null;
    main_type: string;
    by: string;
    id: number;
    can_edit?: 0 | 1;
}


// to single object maping
export const mapShareContactType = (data: any): ShareContactTypes => {
    if (!data) {
        throw new Error('Invalid Projects')
    }
    const contact: ShareContactTypes = {
        project_id: data.project_id,
        first_name: data.first_name,
        last_name: data.last_name,
        company_name: data.company_name,
        profile_image: data.profile_image,
        mobile: data.mobile,
        landline: data.landline,
        email: data.email,
        address: data.address ?? null,
        city: data.city ?? null,
        post_code: data.post_code ?? null,
        role_name: data.role_name,
        main_type: data.main_type,
        by: data.by,
        id: data.id,
        can_edit: data.can_edit
    }
    return contact;
}

// maping list objects
export const mapShareContactTypes = (data: any[]): ShareContactTypes[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Contacts');
    }
    return data.map(mapShareContactType);
}

